import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastProvider } from "./ui/Toast";
import { BrowserRouter } from "react-router";
import { App } from "./App.js";
import "./styles/global.css";
import { applyTheme, getTheme } from "./lib/theme.js";
import { initSentry } from "./sentry-init.js";
import { installErrorReporter } from "./lib/error-reporter.js";
import { initAnalytics } from "./lib/analytics.js";

// Init Sentry (no-op si VITE_SENTRY_DSN absent au build).
initSentry();
// Analytics PostHog (no-op si VITE_POSTHOG_KEY absent au build).
initAnalytics();
// Monitoring maison : capture window.onerror + unhandledrejection.
installErrorReporter();

// Applique le thème avant le 1er paint pour éviter le flash.
applyTheme(getTheme());

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Élément #root introuvable");

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ToastProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
